import logo2005 from "../../assets/img/historicEvents/LogoONS/2005.png";
import logo2006 from "../../assets/img/historicEvents/LogoONS/2006.png";
import logo2007 from "../../assets/img/historicEvents/LogoONS/2007.png";
import logo2008 from "../../assets/img/historicEvents/LogoONS/2008.png";

export const oneNightStandDetail = {
  "one-night-stand": {
    id: "one-night-stand",
    title: "One Night Stand",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "one-night-stand",
        items: [
          {
            id: "one-night-stand-2005",
            title: "ECW One Night Stand",
            description: "2005",
            imgUrl: logo2005,
          },
          {
            id: "one-night-stand-2006",
            title: "ECW One Night Stand",
            description: "2006",
            imgUrl: logo2006,
          },
          {
            id: "one-night-stand-2007",
            title: "One Night Stand",
            description: "Extreme Rules 2007",
            imgUrl: logo2007,
          },
          {
            id: "one-night-stand-2008",
            title: "One Night Stand",
            description: "The One Night a Year When the WWE Goes Extreme 2008",
            imgUrl: logo2008,
          },
        ],
      },
    ],
  },
};
